/* eslint-disable react/prop-types */ // TODO: add props
import { Fragment } from 'react';
import cx from 'classnames';
import { Table } from 'edrolo/domains/teacherResultsTable';
import style from './QuestionTableHeader.scss';
import QuestionColumnHeader from './QuestionColumnHeader';

const Sort = ({ asc }) => (
  <i
    className={cx(style.iconArrow, {
      ['icon-arrow-dropdown']: !asc,
      ['icon-arrow-dropup']: asc,
    })}
  />
);

const QuestionTableHeader = ({
  examId,
  sections,
  sectionQuestions,
  flatQuestions,
  getQuestionReviewUrl,
  onSelectSort,
  sortColumn,
  sortAscending,
  indicesToAddSpacerCellTo,
  analyticsPayload,
}) => (
  <Table.Head isSticky>
    <Table.Row className={style.sectionHeaders}>
      <Table.ColHeader isSticky isHorizSticky />
      <Table.ColHeader
        className={cx(
          style.topHeader,
          style.verticalCellWrapper,
          style.sortable
        )}
        rowSpan={2}
        onClick={() => {
          onSelectSort('understands');

          global.analytics.track(
            'sorted question set results grid by understands count',
            analyticsPayload
          );
        }}
      >
        <div className={cx(style.verticalContents)}>
          Understands{' '}
          {sortColumn === 'understands' ? <Sort asc={sortAscending} /> : null}
        </div>
      </Table.ColHeader>

      {sections.map((section) => {
        const numQuestions = sectionQuestions.get(`${section.get('id')}`).size;

        return (
          <Fragment key={`section-${section.get('id')}`}>
            <Table.ColHeader
              colSpan={numQuestions}
              className={cx(style.topHeader, style.sectionHeader)}
            >
              {section.get('title') || `Section ${section.get('serial')}`}
            </Table.ColHeader>
            <Table.ColHeader spacer />
          </Fragment>
        );
      })}
    </Table.Row>
    <Table.Row>
      <Table.ColHeader
        isHorizSticky
        onClick={() => {
          onSelectSort('name');

          global.analytics.track(
            'sorted question set results grid by student name',
            analyticsPayload
          );
        }}
        className={cx(style.topHeader, style.sortable, style.nameHeader)}
      >
        Student Name{' '}
        {sortColumn === 'name' ? <Sort asc={sortAscending} /> : null}
      </Table.ColHeader>

      {flatQuestions.toArray().map((question, idx) => {
        return (
          <Fragment key={`question-header-${question.get('id')}`}>
            <QuestionColumnHeader
              examId={examId}
              to={getQuestionReviewUrl(question.get('id'))}
              questionReviewUrl={getQuestionReviewUrl(question.get('id'))}
              question={question}
              analyticsPayload={analyticsPayload}
            />
            {indicesToAddSpacerCellTo?.includes(idx) ? (
              <Table.ColHeader spacer />
            ) : null}
          </Fragment>
        );
      })}
    </Table.Row>
  </Table.Head>
);

export default QuestionTableHeader;
